export default __webpack_public_path__ + "static/feature6-6234eef6c924b1df197be7ec40865eaa.webp";